import React, { Component } from "react";
import { Container, Header, Table, Segment, Dimmer, Loader } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import MainMenu from "./../components/MainMenu";
import { getGlobalRoomView } from "../lib/roomService";

const REFRESH_INTERVAL_MS = 15000;

class GlobalView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rooms: [],
      loading: true,
    };
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    this.refresh();
    this.intervalId = setInterval(this.refresh, REFRESH_INTERVAL_MS);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  async refresh() {
    const rooms = await getGlobalRoomView();
    this.setState({ rooms: rooms || [], loading: false });
  }

  render() {
    const { t } = this.props;
    const { rooms, loading } = this.state;

    return (
      <Container>
        <MainMenu />
        <Header as="h2" textAlign="left" style={{ marginTop: "1em" }}>
          {t("general.globalView")}
        </Header>

        <Segment basic style={{ minHeight: "200px" }}>
          <Dimmer active={loading} inverted>
            <Loader>{t("general.loading")}</Loader>
          </Dimmer>

          {!loading && rooms.length === 0 ? (
            <p>{t("GlobalView.noActiveRooms")}</p>
          ) : (
            <Table striped celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("GlobalView.room")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("GlobalView.students")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("GlobalView.proctor")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {rooms.map((room) => (
                  <Table.Row key={room.room_id}>
                    <Table.Cell>
                      <strong>{room.room_title}</strong>
                    </Table.Cell>
                    <Table.Cell>{room.student_count}</Table.Cell>
                    <Table.Cell>
                      {room.proctors.length > 0
                        ? room.proctors
                            .map(
                              (proctor) =>
                                `${proctor.first_name} ${proctor.last_name} – ${proctor.username}`
                            )
                            .join(", ")
                        : t("GlobalView.noProctor")}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
        </Segment>
      </Container>
    );
  }
}

export default withTranslation()(GlobalView);
